import type { WorkPlanParsePreview } from '@ashniva/types';
import { Alert } from '@ashniva/ui';

/** A brief's proposed plan while it is being reviewed, and the file it was read from. */
export interface ReviewedProposal extends WorkPlanParsePreview {
  fileName: string;
}

/**
 * Says plainly that the plan in the editor is a proposal: nothing is saved and no task exists
 * until the reviewer saves it. Lines that read like instructions to an AI are listed so they are
 * read before they become task titles — a brief is often the client's own document.
 */
export function WorkPlanProposalNotice({ proposal }: { proposal: ReviewedProposal }) {
  return (
    <>
      <Alert tone="warning" title="Proposed plan — not saved yet">
        Read from {proposal.fileName}. Review and edit it below. Nothing is saved and no task is
        created until you press Save plan and create tasks
        {proposal.replacesExistingPlan ? ', which replaces the current plan' : ''}. Cancel discards
        it.
      </Alert>
      {proposal.warnings.length > 0 ? (
        <Alert tone="danger" title="Check these lines before saving">
          <p>
            They read like instructions to an AI rather than work to do. Nothing in them has been
            acted on; remove or reword them if they are not real work.
          </p>
          <ul>
            {proposal.warnings.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </Alert>
      ) : null}
    </>
  );
}
